import { Component } from '@angular/core';
import { AuthenticationService, UserService } from '@app/_services';
import { UntypedFormBuilder, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { FormDataHelper } from '@app/_helpers';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmDialogComponent } from '@app/shared/components/confirm-dialog/confirm-dialog.component';
import { MatIconRegistry, MatIconModule } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgIf } from '@angular/common';
import { Router } from '@angular/router';

const VERIFIED_ICON = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 23"><rect x="1.86" y="6.8" width="1.56" height="1.4" fill="#3a3a3a"/><rect x="1.86" y="10.97" width="1.56" height="1.4" fill="#3a3a3a"/><rect x="1.86" y="8.89" width="1.56" height="1.4" fill="#3a3a3a"/><path d="M8.35,8.89H5.77v1.4H9.09c.22-.09.45-.16.68-.23A4.59,4.59,0,0,1,8.35,8.89Z" fill="#3a3a3a"/><path d="M5.77,12.37h.47A7.59,7.59,0,0,1,7.79,11h-2Z" fill="#3a3a3a"/><path d="M23.51,15.09V13.71A.85.85,0,0,0,23,12.9l-3.75-1.65a.87.87,0,0,0-.77,0l-1.55.68a6.33,6.33,0,0,0-3.57-1.86,4.27,4.27,0,1,0-5.76-4,2,2,0,0,0,0,.24l-2.45.76V4.19h-5V15H5a13.15,13.15,0,0,0-.73,2.55.69.69,0,0,0,.56.81h.13a.7.7,0,0,0,.69-.57C6,15.86,7,12.89,9.77,11.8l1,1.53-1.2,4.81a.71.71,0,0,0,.2.69l1.67,1.54a.66.66,0,0,0,.47.19.7.7,0,0,0,.5-.21L14,18.81a.72.72,0,0,0,.18-.67L13,13.36l1.22-1.61a5,5,0,0,1,1.34.8l-.75.33a.9.9,0,0,0-.57.87q0,1.27,0,2.55a3.07,3.07,0,0,0,.05.53,7.11,7.11,0,0,0,2.3,4.22,5.36,5.36,0,0,0,1.9,1.07,1.18,1.18,0,0,0,.41.07,1.23,1.23,0,0,0,.42-.07,5.66,5.66,0,0,0,2.64-1.83,7.22,7.22,0,0,0,1.18-2A5.77,5.77,0,0,0,23.51,16c0-.2,0-.4,0-.61ZM11.87,3.19A2.88,2.88,0,1,1,9,6.07,2.88,2.88,0,0,1,11.87,3.19ZM3.77,13.58H1.52v-8H3.77v8Zm1.91,0H5.17v-5l2.66-.83.1,0a4.33,4.33,0,0,0,2.62,2.37A7.17,7.17,0,0,0,5.68,13.58Zm6.23,5.31-.86-.81.82-3.27.82,3.29Zm0-6.45-.67-1a9.09,9.09,0,0,1,.93-.06,4.57,4.57,0,0,1,.52.05Zm9.9,5.31a6.08,6.08,0,0,1-1,1.65,4.44,4.44,0,0,1-1.94,1.4,4,4,0,0,1-1.42-.8,5.66,5.66,0,0,1-1.85-3.42,1.24,1.24,0,0,1,0-.27c0-.76,0-1.51,0-2.26l3.26-1.44,3.26,1.44v2A4.32,4.32,0,0,1,21.78,17.75Z" fill="#3a3a3a"/><path d="M21.15,15.2a.64.64,0,0,0-.91,0l-2,1.92-.32-.56a.64.64,0,0,0-.87-.25.63.63,0,0,0-.24.87l.72,1.29a.63.63,0,0,0,.47.32h.09a.63.63,0,0,0,.45-.18l2.57-2.5A.63.63,0,0,0,21.15,15.2Z" fill="#3a3a3a"/></svg>'
@Component({
    selector: 'app-page-profile',
    templateUrl: './page-profile.component.html',
    styleUrls: ['./page-profile.component.scss'],
    providers: [FormDataHelper],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, MatIconModule, NgIf, MatSlideToggleModule, TranslateModule]
})
export class PageProfileComponent {
    constructor(private fb: UntypedFormBuilder,
        private authService: AuthenticationService,
        private userService:UserService,
        private toastr: ToastrService,
        private formDataHelper: FormDataHelper,
        private modalService: BsModalService,
        private router : Router,
        iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
            iconRegistry.addSvgIconLiteral('verified', sanitizer.bypassSecurityTrustHtml(VERIFIED_ICON));
         }
    userDetails;
    bsModalRef: BsModalRef;
    form = this.fb.group({
        name: ['', Validators.required],
        mobile: [null],
        email: new UntypedFormControl({ value: null, disabled: true })
    });

    ngOnInit() {
        this.authService.currentUser.subscribe((user): any => {
            this.userDetails = user;
        });
        if (this.userDetails?.businessInfo) {
            this.businessUser = true;
            this.form.addControl('businessInfo', this.fb.group({
                name: [null, Validators.required],
                vatCert: [null, Validators.required],
                cr:[null, Validators.required]
            }));
        }
        this.form.patchValue(this.userDetails);

    }

    businessUser = false;

    onToggle(evento) {

        if (evento.checked) {
            this.form.addControl('businessInfo', this.fb.group({
                name: [this.userDetails?.businessInfo?.name, Validators.required],
                vatCert: [this.userDetails?.businessInfo?.vatCert, Validators.required],
                cr:[this.userDetails?.businessInfo?.cr, Validators.required]
            }));
        } else {
            if (!this.userDetails?.BusinessInfo)
                this.form.removeControl('businessInfo');
        }
        this.businessUser = evento.checked;
    }

    handleFileInput(name, file: any) {
        const reader = new FileReader();
        reader.onload = () => {
            this.urls[name] = reader.result as string;
        }
            this.form.get(name).patchValue(file[0]);

    }

    remove(name, element) {
        element.value = '';
        this.form.get(name).patchValue(null);
    }

    update() {
        if (!this.form.valid) return this.toastr.error('Please fill required fields.')

        let formdata = this.formDataHelper.ToFormData(this.form.value);
        this.userService.update(formdata).subscribe(response => {

            if (response.code == 200) {
                this.toastr.success(response.msg)
                this.userDetails = response.data;
            } else {
                this.toastr.error(response.msg);
            }

        }, error => {
            this.toastr.error(error.error.msg)
        })
    }

    delete() {
        let id = this.authService.currentUserValue._id;
        if (!id) return this.toastr.error('User not found');
        this.bsModalRef = this.modalService.show(ConfirmDialogComponent, { class: 'modal-sm' });
        this.bsModalRef.content.onClose.subscribe((confirmed) => {
            if (confirmed) {
                this.userService.delete().subscribe(response => {
                if (response.code == 200) {
                this.authService.resetUser();
                this.toastr.success(response.msg)
                this.router.navigate(['/']);
            } else {
                this.toastr.error(response.msg);
            }

        }, error => {
            this.toastr.error(error.error.msg)
        })
    }
        });
        
    }

    changeType() {
        this.bsModalRef = this.modalService.show(ConfirmDialogComponent, { class: 'modal-sm' });
        this.bsModalRef.content.onClose.subscribe((confirmed) => {
            if (confirmed) {
                this.userService.changeType().subscribe(response => {
                    if (response.code == 200) {
                        this.toastr.success(response.msg);
                        this.userDetails = response.data;
                        this.form.removeControl('businessInfo');
                        this.businessUser = false;
                        this.form.patchValue(response.data);
                    } else {
                        this.toastr.error(response.msg);
                    }
                }, error => {
                    this.toastr.error(error.error.msg)
                })
            }
        });

    }

    get firstname() {
        return this.form.get('firstname');
    }
    get lastname() {
        return this.form.get('lastname');
    }

    urls

    get crUrl() {
        //console.log(this.urls?.cr ?? this.form.get('businessInfo.cr')?.value?.cr?.url);
        return this.urls?.cr ?? this.form.get('businessInfo.cr')?.value?.cr?.url;
    }

    get vatCertUrl() {
        return this.urls?.vatCert ?? this.form.get('businessInfo.vatCert')?.value?.vatCert?.url
    }
}
